export const maskNumber = (value: string) => {
  if (value == null || value === '') return '';
  return value.replace(/\D/g, '').replace(/^0*(\d+)/, '$1');
};

export const formatNumber = (num: number, decimal: number = 4) => {
  if (Number.isInteger(num)) {
    return num.toString();
  } else {
    return parseFloat(num.toFixed(decimal)).toString();
  }
};
